<template>
  <div class="VaelgHotel">
    <h1>{{ $t('vaelgby') }}</h1>
    <!-- Vis 'loading' ikon mens API data loader... -->
    <img v-if="this.$store.getters.loading === true" src="@/assets/loading.svg" alt="" class="center">
    <!-- <p>Sprog: {{ this.language }}</p> -->
    <div class="chooser">
      <hotelChooser koncern:this.koncern />
    </div>
  </div>
</template>

<script>
import hotelChooser from "@/components/hotelChooser.vue";
//import i18n from "@/plugins/i18n";

export default {
  data() {
    return {
      language: 'default',
    }
  },
  name: "App",
  components: {
    hotelChooser
  },
  methods: {
    //
  },
  created() {
    //i18n.locale = 'es';
    localStorage.removeItem('refNo');
    this.language = navigator.language || navigator.userLanguage;
  }
};
</script>

<style scoped>
.chooser {
  display:inline-block;
}

h1 {
  font-size: 400%;
  margin-bottom: 120px;
}

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}

/* når viewport er mindre end 960 px */
@media (max-width: 959px) {
  /* Mindre overskrift */
  h1 {
    font-size: 200%;
    margin-bottom: 20px;
  }

}

</style>
